import { udpApi } from 'yxt-biz-pc/packages/api';

export const saveVisitors = data => {
  return udpApi.post('/external/users/importsearch', data);
};

// 获取外部账号导入模版
export const getExternalUsersDownload = () => {
  return udpApi.get('/external/users/template/download');
};
